import { Link } from 'react-router-dom';

const EmptyBlockInventoryCraft = ({img, icon, path, text}) => {

  return (
    <div className="empty-packs">
      <img src={img} className="empty-packs__pic" alt="" />
      <h2 className="empty-packs__title">{text}</h2>
      <Link className="craft-placeholder__button" to={path}>
        <img src={icon} alt='' />
        {
          text.includes('Identity') ? 'Craft Identity' : 'Craft Prediction'
        }
      </Link>
    </div>
  )
}

export default EmptyBlockInventoryCraft;
